var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSaveActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#20ABAD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3001_13896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9974 16.9986C9.24245 16.9986 7.48664 17.0002 5.73166 16.9977C4.64517 16.9961 4.0024 16.3574 4.00157 15.2759C3.99991 11.7519 3.99908 8.22783 4.00157 4.70295C4.0024 3.64714 4.64932 3.00354 5.7101 3.00188C8.65358 2.99939 11.5979 2.9969 14.5414 3.01183C14.7338 3.01266 14.971 3.11302 15.1095 3.24738C16.0135 4.12155 16.9018 5.01231 17.7793 5.91302C17.8979 6.03411 17.9883 6.24145 17.9891 6.40982C18.0016 9.39477 18.0024 12.3806 17.9958 15.3655C17.9933 16.3433 17.3298 16.9944 16.3461 16.9977C14.5629 17.0027 12.7798 16.9986 10.9974 16.9986ZM5.58569 4.58435C5.58569 5.63103 5.58569 6.63375 5.58569 7.64643C8.18001 7.64643 10.7536 7.64643 13.3255 7.64643C13.3255 6.60804 13.3255 5.60532 13.3255 4.58435C10.7387 4.58435 8.17669 4.58435 5.58569 4.58435ZM11.0248 15.4335C12.2987 15.4294 13.3429 14.3868 13.3479 13.1154C13.3529 11.8356 12.2855 10.7749 10.9949 10.7774C9.70524 10.7798 8.63783 11.8481 8.6511 13.1245C8.66437 14.415 9.71602 15.4385 11.0248 15.4335Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3001_13896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(4 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSaveActive);
export default __webpack_public_path__ + "static/media/ic_save_active.5468b3f908cb095bf47681a98b649453.svg";
export { ForwardRef as ReactComponent };